const PREFIX = 'AUTH.';
export const SEND_LOGOUT_WARNING = `${PREFIX}SEND_LOGOUT_WARNING`;
export const CLEAR_AUTHENTICATION = `${PREFIX}CLEAR_AUTHENTICATION`;
export const SET_AUTHENTICATION = `${PREFIX}SET_AUTHENTICATION`;
export const AUTHENTICATION_REQUEST = `${PREFIX}AUTHENTICATION_REQUEST`;
export const AUTHENTICATION_FAILURE = `${PREFIX}AUTHENTICATION_FAILURE`;
export const AUTHENTICATION_SUCCESS = `${PREFIX}AUTHENTICATION_SUCCESS`;
export const CHANGE_AUTHORIZATION_TYPE = `${PREFIX}CHANGE_AUTHORIZATION_TYPE`;
export const CLEAR_STATE = 'CLEAR_STATE';



// WEBPACK FOOTER //
// ./src/auth/state/types.js